/*
 * Contesto lingua del manager NeoFlux.
 * Rilevamento: cookie condiviso `nfx_lang` (dominio .neoflux.it) → altrimenti la
 * `lingua` del profilo utente → altrimenti italiano.
 * Cambio lingua: aggiorna stato + cookie condiviso (segue l'utente su auth/welcome)
 * e, se loggato, persiste `lingua` sul profilo.
 */
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { translate } from '../i18n';

const LinguaContext = createContext({ locale: 'it', setLocale: () => {}, t: (k) => k });

const COOKIE = 'nfx_lang';
function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
  return m ? decodeURIComponent(m[1]) : null;
}
function writeCookie(name, val) {
  try {
    const d = new Date(); d.setFullYear(d.getFullYear() + 1);
    const base = `${name}=${encodeURIComponent(val)};path=/;expires=${d.toUTCString()};SameSite=Lax`;
    // Cookie condiviso sul dominio radice (segue auth/welcome/manager); fallback host-only.
    document.cookie = `${base};domain=.neoflux.it`;
    document.cookie = base;
  } catch (e) { /* dev/localhost: ignora */ }
}

export function LinguaProvider({ children }) {
  const { utente } = useAuth();
  const [locale, setLoc] = useState(() => readCookie(COOKIE) || 'it');

  // Se non c'è un cookie esplicito, adotta la lingua del profilo appena disponibile.
  useEffect(() => {
    if (!readCookie(COOKIE) && utente?.lingua && utente.lingua !== locale) setLoc(utente.lingua);
  }, [utente?.lingua, locale]);

  const setLocale = useCallback((l) => {
    setLoc(l);
    writeCookie(COOKIE, l);
    axios.put('/api/profilo', { lingua: l }, { withCredentials: true }).catch(() => {});
  }, []);

  const t = useCallback((key, vars) => translate(locale, key, vars), [locale]);

  return <LinguaContext.Provider value={{ locale, setLocale, t }}>{children}</LinguaContext.Provider>;
}

export const useLingua = () => useContext(LinguaContext);
export const useT = () => useContext(LinguaContext).t;
